
//staging
// export let ApiKey ="eMeCh4aYoitxNyY6WHH30TaOV0vuKp4xE6FmN0g5vDT";
//production
export let ApiKey = "MYgRWv2Uuyk6kyIDRSp2iW4gF1cBmbMe4LpHJQJL5f7";


export let getBearerToken = () => {
    return new Promise((resolve, reject) => {
        fetch("https://ws.api.video/auth/api-key", {
            method: "POST",
            headers: { 'Content-Type': "application/json" },
            body: JSON.stringify({ "apiKey": "MYgRWv2Uuyk6kyIDRSp2iW4gF1cBmbMe4LpHJQJL5f7" })
        })
            .then(response => response.json())
            .then(response => {
                if (response.access_token) {
                    resolve(response.access_token);
                }
            }).catch((error) => {
                reject(error);
            });
    });
}

export let generateUploadToken = (bearerToken) => {
    return new Promise((resolve, reject) => {
        fetch("https://ws.api.video/upload-tokens", {
            method: "POST",
            headers: {
                Accept: "application/json",
                'Content-Type': "application/json",
                Authorization: 'Bearer ' + bearerToken
            },
            body: JSON.stringify({ ttl: 0 })
        })
            .then(response => response.json())
            .then(response => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    });
}
export let createLiveStreamUrl = (bearerToken, body) => {
    return new Promise((resolve, reject) => {
        fetch("https://ws.api.video/live-streams", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": "Bearer " + bearerToken
            },
            body: JSON.stringify(body)
        })
            .then(response => response.json(body))
            .then(response => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
export let getVideoStatus = (bearerToken, videoId) => {
    return new Promise((resolve, reject) => {
        fetch("https://ws.api.video/videos/" + videoId + "/status", {
            method: "GET",
            headers: {
                Accept: "application/json",
                'Content-Type': "application/json",
                Authorization: "Bearer " + bearerToken
            }
        })
            .then(response => response.json())
            .then(response => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export let getVideoDetails = (bearerToken, videoId) => {
    return new Promise((resolve, reject) => {
        fetch("https://ws.api.video/videos/" + videoId, {
            method: "GET",
            headers: {
                Accept: "application/json",
                'Content-Type': "application/json",
                Authorization: 'Bearer ' + bearerToken
            }
        })
            .then((response) => response.json())
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function extractApiVideoDuration(videoPayload) {
    const candidates = [
        videoPayload?.encoding?.metadata?.duration,
        videoPayload?.metadata?.duration,
        videoPayload?.duration,
    ];
    if (Array.isArray(videoPayload?.metadata)) {
        const fromMeta = videoPayload.metadata.find((item) =>
            /duration/i.test(String(item?.key ?? item?.name ?? ""))
        );
        if (fromMeta) {
            candidates.push(fromMeta.value);
        }
    }
    for (const value of candidates) {
        const total = Number(value);
        if (Number.isFinite(total) && total > 0) {
            return total > 1000 ? Math.round(total / 1000) : Math.round(total);
        }
    }
    return null;
}

export function extractApiVideoTitle(videoPayload) {
    const candidates = [videoPayload?.title, videoPayload?.name];
    for (const value of candidates) {
        const text = String(value ?? "").trim();
        if (
            text &&
            !/^video\s+\d+$/i.test(text) &&
            !/^qrtagvideo$/i.test(text) &&
            text.toLowerCase() !== "file"
        ) {
            return text;
        }
    }
    return "";
}

export let updateVideoTitle = (bearerToken, videoId, title) => {
    const name = String(title ?? "").trim();
    if (!bearerToken || !videoId || !name) {
        return Promise.resolve(null);
    }
    return fetch("https://ws.api.video/videos/" + videoId, {
        method: "PATCH",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + bearerToken
        },
        body: JSON.stringify({ title: name })
    }).then((response) => response.json());
};

/** Extract a stable ISO timestamp (upload time) from an api.video details payload. */
export function extractApiVideoTimestamp(videoPayload) {
    const candidates = [
        videoPayload?.createdAt,
        videoPayload?.publishedAt,
    ];
    for (const value of candidates) {
        if (value == null || value === "") continue;
        const parsed = Date.parse(value);
        if (!Number.isNaN(parsed)) {
            return new Date(parsed).toISOString();
        }
    }
    return null;
}

const Exports = {
    getBearerToken,
    createLiveStreamUrl,
    generateUploadToken,
    getVideoStatus,
    getVideoDetails,
    extractApiVideoDuration,
    extractApiVideoTimestamp,
    extractApiVideoTitle,
    updateVideoTitle,
}
export default Exports;